import React from 'react';
import { StaticPageLayout } from './StaticPageLayout';
import { UgcRulesContent } from './UgcRulesContent';

/**
 * `/ugc-rules` — правила публикации отзывов и фотографий.
 *
 * На эту страницу ссылается лист отправки отзыва в приложении, поэтому адрес
 * менять нельзя: ссылка зашита в мобильный клиент.
 */
export const UgcRulesPage: React.FC = () => (
  <StaticPageLayout
    kicker="Правовая информация"
    title="Правила публикации"
    documentTitle="QPrice — Правила публикации"
    updatedAt="15 августа 2026 года"
  >
    <div className="qp-prose">
      <UgcRulesContent />
    </div>
  </StaticPageLayout>
);
